"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));

require("./FieldRange.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class FieldRange extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onBlur", event => {
      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
    });

    _defineProperty(this, "onFocus", event => {
      if (this.props.onFocus) {
        this.props.onFocus(event);
      }
    });

    _defineProperty(this, "onChange", (event, value) => {
      this.setState({
        value: value
      });

      if (this.props.onChange) {
        this.props.onChange(value, event);
      }
    });

    _defineProperty(this, "getAriaValue", value => {
      return value;
    });

    this.state = {
      value: props.value
    };
  }

  render() {
    const _this$props = this.props,
          id = _this$props.id,
          disabled = _this$props.disabled,
          readonly = _this$props.readonly,
          value = _this$props.value,
          step = _this$props.step,
          min = _this$props.min,
          max = _this$props.max,
          marks = _this$props.marks;
    return _react.default.createElement("div", {
      className: "admin-field  field--range"
    }, _react.default.createElement(_Slider.default, {
      defaultValue: value,
      getAriaValueText: this.getAriaValue,
      "aria-labelledby": id,
      valueLabelDisplay: "auto",
      step: step,
      marks: marks,
      min: min,
      max: max,
      onChange: (event, value) => this.onChange(event, value)
    }));
  }

}

_defineProperty(FieldRange, "defaultProps", {
  value: "",
  required: false,
  autofocus: false
});

var _default = FieldRange;
exports.default = _default;
module.exports = exports.default;